'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const PersonStatisticsViewModel=require('../../../dist-es6/client/viewModels/personStatisticsViewModel');
const IncidentViewModel=require('../../../dist-es6/client/viewModels/incidentViewModel');
const Formatters=require('../../../dist-es6/client/formatters');
const ForecastPersonViewModel=require('../../../dist-es6/client/viewModels/forecastPersonViewModel');
const BaseDirective=require('../../../dist-es6/client/angularCommon/baseDirective');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');let

SparklineDirective=function(_BaseDirective){_inherits(SparklineDirective,_BaseDirective);function SparklineDirective(){_classCallCheck(this,SparklineDirective);return _possibleConstructorReturn(this,_BaseDirective.apply(this,arguments))}SparklineDirective.prototype.








link=function link(scope,element){
const svgWidth=scope.svgWidth?+scope.svgWidth:350;
const svgHeight=scope.svgHeight?+scope.svgHeight:46;
const minFatigueValue=3;
const maxFatigueValue=25.5;

const sparklineGraph=new SparklineGraph(element,svgWidth,svgHeight,minFatigueValue,maxFatigueValue);

scope.$watchGroup(['viewModel','selectedNotificationType'],function(newlySelectedNotificationType){
sparklineGraph.redraw(scope.selectedNotificationType,scope.viewModel);
});
};_createClass(SparklineDirective,[{key:'restrict',get:function(){return'E'}},{key:'objectBindings',get:function(){return['viewModel','selectedNotificationType','svgWidth','svgHeight']}}]);return SparklineDirective}(BaseDirective);let


SparklineGraph=function(){
function SparklineGraph(element,svgWidth,svgHeight,minFatigueValue,maxFatigueValue){_classCallCheck(this,SparklineGraph);
this._element=element;
this._svgWidth=svgWidth;
this._svgHeight=svgHeight;
this._minFatigueValue=minFatigueValue;
this._maxFatigueValue=maxFatigueValue;

this._deviationMarkerHeight=16;
this._thresholdLineOffset=0.5;
this._midpointY=this._svgHeight/2;

this._xScale=d3.scale.linear().
domain([this._minFatigueValue,this._maxFatigueValue]).
range([0,this._svgWidth]);

this._singleUnitWidthInPixels=Math.ceil(this._xScale(2)-this._xScale(1));

this._element.append(`<svg width="${this._svgWidth}" height="${this._svgHeight}"></svg>`);
this._svg=d3.select(this._element[0].getElementsByTagName('svg')[0]);

this._axisGroup=this._svg.append('g').attr({class:'axis'});
this._deviationRangeGroup=this._svg.append('g').attr({class:'deviation-range'});
this._effectiveThresholdGroup=this._svg.append('g').attr({class:'effective-threshold'});
this._currentFatigueGroup=this._svg.append('g').attr({class:'fatigue-points'});
this._peakWorkdayFatigueGroup=this._svg.append('g').attr({class:'peak-forecast'});
}SparklineGraph.prototype.

_getXPositionFor=function _getXPositionFor(thresholdValue){let offset=arguments.length>1&&arguments[1]!==void 0?arguments[1]:0;let isRounded=arguments.length>2&&arguments[2]!==void 0?arguments[2]:!0;
let clampedDomainValue=_.clamp(thresholdValue,this._minFatigueValue+offset,this._maxFatigueValue+offset);
let nonIntegerRangeValue=this._xScale(clampedDomainValue-offset);
return isRounded?Math.round(nonIntegerRangeValue):nonIntegerRangeValue;
};SparklineGraph.prototype.

_getRequiredData=function _getRequiredData(viewModel,selectedNotificationType){
if(viewModel instanceof PersonStatisticsViewModel){
return{
averageDailyLow:viewModel.averageDailyLow,
averageDailyHigh:viewModel.averageDailyHigh,
topDailyHighs:viewModel.topDailyHighs,
effectiveThreshold:viewModel.thresholdFor(selectedNotificationType)};

}

if(viewModel instanceof IncidentViewModel){
return{
averageDailyLow:_.get(viewModel,'statistics.recentHistory.fatigue.averageDailyLow'),
averageDailyHigh:_.get(viewModel,'statistics.recentHistory.fatigue.averageDailyHigh'),
topDailyHighs:_.get(viewModel,'statistics.recentHistory.fatigue.topDailyHighs'),
effectiveThreshold:viewModel.thresholdFor(selectedNotificationType)};

}

throw new Error(`[${this.constructor.name}] Expected either view model of type 'PersonStatisticsViewModel' or 'IncidentViewModel' - got ${viewModel.constructor.name}`);
};SparklineGraph.prototype.

_drawDeviationRangeAndEffectiveThreshold=function _drawDeviationRangeAndEffectiveThreshold(viewModel,selectedNotificationType){var _this2=this;
if(!_.exists(viewModel)){
return!1;
}

const{
averageDailyLow:averageDailyLow,
averageDailyHigh:averageDailyHigh,
topDailyHighs:topDailyHighs,
effectiveThreshold:effectiveThreshold}=
this._getRequiredData(viewModel,selectedNotificationType);

let drawXAxis=!1;

if(_.allExist(averageDailyLow,averageDailyHigh)){
let deviationRangeMin=Math.floor(averageDailyLow);
let deviationRangeMax=Math.ceil(averageDailyHigh);

const deviationRangeLine=this._deviationRangeGroup.
selectAll(`line`).
data([{deviationRangeMin:deviationRangeMin,deviationRangeMax:deviationRangeMax}]);

deviationRangeLine.
enter().
append('line').
style({
"stroke-width":this._singleUnitWidthInPixels*0.7,
stroke:'#C3CDCF'});


deviationRangeLine.
exit().
remove();

deviationRangeLine.
transition().duration(200).
attr({
x1:function(_ref){let{deviationRangeMin:deviationRangeMin}=_ref;return _this2._getXPositionFor(deviationRangeMin,_this2._thresholdLineOffset)-0.5},
x2:function(_ref2){let{deviationRangeMax:deviationRangeMax}=_ref2;return _this2._getXPositionFor(deviationRangeMax,_this2._thresholdLineOffset)-0.5},
y1:this._midpointY,
y2:this._midpointY,
class:'deviation-range'});

}else{
this._deviationRangeGroup.
selectAll(`line`).
remove();
}

if(_.exists(effectiveThreshold)){
drawXAxis=!0;
let deviationThresholdX=this._getXPositionFor(effectiveThreshold,this._thresholdLineOffset)-0.5;
let markerHalfHeight=this._deviationMarkerHeight/2;

let isWithinVisibleRange=deviationThresholdX<this._svgWidth;
if(!isWithinVisibleRange){
deviationThresholdX=this._svgWidth-1;
}

const deviationThresholdLine=this._effectiveThresholdGroup.
selectAll(`line`).
data([deviationThresholdX].filter(function(value){return _existsAndIsANumber(value)}));

deviationThresholdLine.
enter().
append('line').
style({
"stroke-width":1,
stroke:isWithinVisibleRange?
'#6A8187':
'#DE1A1C'});


deviationThresholdLine.
exit().
remove();

deviationThresholdLine.
transition().duration(200).
attr({
x1:function(value){return value},
x2:function(value){return value},
y1:this._midpointY-markerHalfHeight,
y2:this._midpointY+markerHalfHeight,
class:'deviation-threshold'});

}else{
this._effectiveThresholdGroup.
selectAll(`line`).
remove();
}

return drawXAxis;
};SparklineGraph.prototype.

_drawFatiguePoints=function _drawFatiguePoints(group,data,thresholdStatus){var _this3=this;
let thresholdStatusClass=Formatters.classFromThresholdStatus(thresholdStatus);
let currentFatiguePoint=group.
selectAll('circle').
data(data.filter(function(_ref3){let{value:value}=_ref3;return _existsAndIsANumber(value)}));

currentFatiguePoint.
enter().
append('circle').
attr({r:0});

currentFatiguePoint.
exit().
transition().duration(200).
attr({r:0}).
each('end',_removeElement);

currentFatiguePoint.
transition().duration(200).
attr({
cx:function(_ref4){let{value:value}=_ref4;return _this3._getXPositionFor(Math.floor(value),0,!0)},
cy:this._midpointY,
r:function(_ref5){let{additionalClasses=[]}=_ref5;
if(additionalClasses.find(function(c){return c==='peak-forecast'})!==void 0){
return 5;
}

if(additionalClasses.find(function(c){return c==='peak-forecast-outline'})!==void 0){
return 7;
}

return _this3._singleUnitWidthInPixels/2;
},
class:function(_ref6){let{additionalClasses=[]}=_ref6;return _(thresholdStatusClass).
mapValues(function(isTrue,className){return isTrue?className:''}).
values().concat(additionalClasses).
join(' ').trim()}});


};SparklineGraph.prototype.

_drawXAxis=function _drawXAxis(){
if(this._axisDrawn){
return;
}

let xAxis=this._axisGroup.
insert('line',':first-child').
attr({
x1:0,
x2:this._svgWidth,
y1:this._midpointY,
y2:this._midpointY,
class:'x-axis'}).

style({
"stroke-width":3,
stroke:'#E1E6E7'});


this._axisDrawn=!0;
};SparklineGraph.prototype.

_clearPlottedFatiguePoints=function _clearPlottedFatiguePoints(group){
this._drawFatiguePoints(group,[],ThresholdStatus.NotApplicable);
};SparklineGraph.prototype.

redraw=function redraw(selectedNotificationType,viewModel){
let drawXAxis=this._drawDeviationRangeAndEffectiveThreshold(viewModel,selectedNotificationType);

if(viewModel instanceof ForecastPersonViewModel){
drawXAxis=!0;

if(_.exists(viewModel,'currentStatus')){
const pointPlotData=[{value:viewModel.currentStatus.fatigue}];

this._drawFatiguePoints(this._currentFatigueGroup,pointPlotData,viewModel.currentStatus.thresholdStatus);
}else{
this._clearPlottedFatiguePoints(this._currentFatigueGroup);
}

if(_.exists(viewModel,'peakWorkdayFatigue')){
const peakWorkdayFatigue=viewModel.peakWorkdayFatigue;
const thresholdStatus=ThresholdStatus.fromScoreAndThreshold(peakWorkdayFatigue,viewModel.currentThreshold);
const pointPlotData=[{
value:peakWorkdayFatigue,
additionalClasses:['peak-forecast-outline']},
{
value:peakWorkdayFatigue,
additionalClasses:['peak-forecast']}];


this._drawFatiguePoints(this._peakWorkdayFatigueGroup,pointPlotData,thresholdStatus);
}else{
this._clearPlottedFatiguePoints(this._peakWorkdayFatigueGroup);
}

}else if(viewModel instanceof IncidentViewModel&&_.exists(viewModel.fatigue)){
drawXAxis=!0;

this._setupFatiguePointFor(viewModel.fatigue,viewModel,selectedNotificationType);
}else if(_.exists(viewModel,'lastKnownStatus.fatigue')){
drawXAxis=!0;

this._setupFatiguePointFor(viewModel.lastKnownStatus.fatigue,viewModel,selectedNotificationType);
}else{
this._clearPlottedFatiguePoints(this._currentFatigueGroup);
}

if(drawXAxis){
this._drawXAxis();
}else if(this._axisGroup){
this._axisGroup.selectAll('*').remove();
this._axisDrawn=!1;
}
};SparklineGraph.prototype.

_setupFatiguePointFor=function _setupFatiguePointFor(value,viewModel,selectedNotificationType){
const pointPlotData=[{value:value}];
const thresholdStatus=viewModel.thresholdStatusFor(selectedNotificationType);

this._drawFatiguePoints(this._currentFatigueGroup,pointPlotData,thresholdStatus);
};return SparklineGraph}();


function _removeElement(){
if(typeof this.remove=='function'){
return this.remove();
}

if(_.exists(this.parentNode)){
return this.parentNode.removeChild(this);
}


}

const _existsAndIsANumber=function(value){return _.exists(value)&&!Number.isNaN(value)};

module.exports=SparklineDirective;
//# sourceMappingURL=sparklineDirective.js.map
